<script setup lang="ts">
import AppFooter from '#/components/layout/AppFooter.vue';
import WorkspaceShell from '#/components/fo/analysis/WorkspaceShell.vue';

/**
 * 워크스페이스 레이아웃 — 2차 AI 입시분석(analysis/*) 전용 셸.
 *
 * 1차 커머스 DefaultLayout(TopStrip+AppHeader)과 완전 분리 — 2차는 자체 GNB를 가지며
 * 서브도메인 배포 시 이 레이아웃이 앱 루트가 된다(docs/frontend-domain-structure-proposal.md).
 *
 * 이 레이아웃은 **도메인 무지 유지** — GNB를 직접 렌더하지 않고 WorkspaceShell(fo/analysis) 한 겹만
 * 조립한다(도메인 지식은 셸 내부에만). AppFooter 는 브랜드/약관 공통이라 재사용(footer slot 주입).
 * TopStrip 은 커머스 카피라 미포함.
 */
</script>

<template>
  <WorkspaceShell>
    <slot />
    <template #footer>
      <AppFooter />
    </template>
  </WorkspaceShell>
</template>
